<template>
  <div class="stu-input">
    <input
        class="el-input__inner"
        v-model="value"
        @input="handleInput"
        :placeholder="placeholder"
    ></input>
    <label class="stu-input-hover">
      {{valueLength}}/{{maxLength}}
    </label>
  </div>
</template>

<script>
export default {
  name: "stu-input-size-limit",
  data(){
    return {
      value:'',
      realLength:0
    }
  },
  methods:{
    handleInput(v){
      if(this.valueLength>this.maxLength){
        this.value=this.value.substr(0,this.realLength)
      }
      this.$emit('input', this.value)
    }
  },
  props:{
    maxLength:{
      type:Number,
      default:0
    },
    minLength:{
      type:Number,
      default:0
    },
    placeholder:{
      type:String,
      default:undefined
    }
  },
  computed:{
    valueLength(){
      let inputValue=this.value
      let valueArray= inputValue.split(' ');
      let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
      let valueLength=0
      if(valueArray){
        for(let x=0;x<valueArray.length;x++){
          let mat = valueArray[x].match(cnReg);
          if(mat){
            valueLength+=mat.length
          }else{
            if(valueArray[x].length>0){
              valueLength+=1
            }
          }
          if(x!=0){
            valueLength+=1
          }
        }
      }
      if(valueLength<=this.maxLength){
        this.realLength=this.value.length
      }
      return valueLength;
    }
  }
}
</script>

<style lang="scss" slot-scope>
.stu-input{
  position: relative;
  width: 240px;
  display: flex;
  align-items: center;
  input{
    padding-right: 50px;
  }
  .stu-input-hover{
    position: absolute;
    right: 5px;
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stu-input/stu-input-size-limit/index.vue